"use client";

import { useProfile } from "../hooks/useProfile";
import Header from "./Header";

export default function DashboardHeader() {
  const { data: profile } = useProfile();
  if (profile?.isGuest) return null;
  return <Header />;
}
